import { defineDocument } from '../../schema';
export const blogReleaseRoundupTwitchAuthModToolsAndMoreDocument = defineDocument({
    id: 'blog:release-roundup-twitch-auth-mod-tools-and-more',
    kind: 'blog',
    slug: 'release-roundup-twitch-auth-mod-tools-and-more',
    route: '/blog/release-roundup-twitch-auth-mod-tools-and-more',
    seo: {
        title: 'Release Roundup: Twitch Auth, Mod Tools, and More',
        description: "We're doubling down on our support for streamers with native Twitch authentication and powerful new moderation tools",
        imageAsset: 'twitchExplosion',
    },
    hero: {
        eyebrow: [
            {
                type: 'text',
                text: 'Airhead Blog',
            },
        ],
        title: [
            {
                type: 'text',
                text: 'Release Roundup: Twitch Auth, Mod Tools, and More',
            },
        ],
        description: [
            {
                type: 'text',
                text: "We're doubling down on our support for streamers with native Twitch authentication and powerful new moderation tools",
            },
        ],
        imageAsset: 'twitchExplosion',
        imageAlt: 'Explosion of Twitch logos',
        showDescription: true,
        background: 'blurred-image',
    },
    meta: {
        author: 'Jay',
        publishedAt: new Date('2025-11-21T00:00:00.000Z'),
        tags: ['features'],
    },
    sections: [
        {
            id: 'article',
            blocks: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: "If you are streaming games to an audience, you know the struggle: you want everyone to join, but you also need to keep the trolls out. November's updates are squarely focused on solving that problem. We've rolled out full Twitch integration, a powerful new mod tool to gatekeep your lobbies, and a massive polish pass on the entire website.",
                        },
                    ],
                },
            ],
            sections: [
                {
                    id: 'article__streamer-first-features-sign-in-with-twitch-player-access-mod-tools',
                    title: [
                        {
                            type: 'text',
                            text: 'Streamer-First Features: Sign In with Twitch & Player Access Mod Tools',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: "We are building a platform designed for streamers, and that starts with seamless integration. You can now log in to Airhead Games directly using your Twitch account. First time authorization takes just a few moments and going forward signing in only takes one click. This isn't just about skipping a password; you can start a game within seconds of landing on our website.",
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'A critical part of this update is the new ',
                                },
                                {
                                    type: 'link',
                                    href: '/discover/features/moderator-tools#player-access',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'player access mod tool',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' for streamers. Enabling this setting requires all players to authenticate with Twitch before joining your game room. By validating players against their Twitch IDs, we help you identify the players in the room, filter out the trolls, and ensure your game room stays focused on your actual community. We know how important it is to control the atmosphere of your stream, and this is the first of many player access mod tools added to the platform.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__platform-polish-upgrades',
                    title: [
                        {
                            type: 'text',
                            text: 'Platform Polish & Upgrades',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: "Beyond the new tools, the entire website has graduated to a fully polished experience. We've overhauled our branding, website navigation, mobile and tablet performance, and gave 'My Settings' its own dedicated page to better manage your account and preferences.",
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'We also tightened up the experience with plenty of bug fixes, UI enhancements, stricter validation for player names, better display in Safari browsers, as well as improved performance of image caching and link sharing. Under the hood we strengthened our user management and logic for tiebreakers in ',
                                },
                                {
                                    type: 'link',
                                    href: '/discover/games/wtf-is-happening',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'WTF Is Happening',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: '. To round out the update, some spicy new flamenco tracks were added to the lobby from our latest artist, ',
                                },
                                {
                                    type: 'link',
                                    href: '/discover/music?artist=popa-del-fuego',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Popa del Fuego',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: '. Visit ',
                                },
                                {
                                    type: 'strong',
                                    children: [
                                        {
                                            type: 'text',
                                            text: '#whats-poppin',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' in our ',
                                },
                                {
                                    type: 'link',
                                    href: 'https://discord.gg/rfFTVAqHwH',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Discord',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' community to see all release notes for November 2025.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__ready-to-play',
                    title: [
                        {
                            type: 'text',
                            text: 'Ready to play?',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'link',
                                    href: '/login',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Log in with Twitch now',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: '.',
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            id: 'article-actions',
            widgets: [
                {
                    type: 'relatedDocuments',
                    limit: 4,
                },
            ],
        },
    ],
});
//# sourceMappingURL=release-roundup-twitch-auth-mod-tools-and-more.js.map